(function () {
    'use strict';

    angular.module('swif.openbase')
    .config(router)
    .factory('AchatsBudgetsService', AchatsBudgetsService)
    .controller('OpenbaseBudgetsController', OpenbaseBudgetsController)
    .controller('BudgetLineEditModalController', BudgetLineEditModalController);

    function router($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/budgets/table_view', {
            templateUrl: 'partials/openbase/configuration_budget_table_view.html',
            controller: 'OpenbaseBudgetsController',
            resolve: {
                data: ['AchatsBudgetsService', function (service) {
                    return service.budgets.resolveData();
                }]
            },
            reloadOnSearch: false
        });
    }

    function AchatsBudgetsService($q, swif, AchatsStocksConfigurationService) {
        'ngInject';
        var service = {};
        service.budgets = {};
        service.budgetLines = {};

        service.budgets.id = 'budgets';
        service.budgetLines.id = 'budget_lines';

        service.budgets.getCollection = function () {
            return swif.collection.getCollection(service.budgets.id);
        };

        service.budgets.getCollectionFilter = function () {
            var filter = {};
            swif.data.addFilter(filter, 'state', 'in', ['confirm', 'validate']);
            swif.data.sortOn(filter, 'id', 'DESC');
            return filter;
        };

        service.budgets.createCollection = function () {
            var filter = service.budgets.getCollectionFilter();
            return swif.collection.createOrUpdate(
                service.budgets.id,
                'crossovered_budget',
                filter,
                {location: true}
            );
        };

        service.budgets.preModal = function (data) {
            console.log(data);
            var ret = service.budgets.getCollection().preModal(data);
            if(data.action.id === 'add') {
                data.model._type = 'crossovered_budget';
            }
            if (data.action.id === 'renew') {
                var dateFrom = moment(data.model.date_from, 'YYYY-MM-DD');
                var dateTo = moment(data.model.date_to, 'YYYY-MM-DD');
                var diffDays = dateTo.diff(dateFrom, 'days');

                var newDateFrom = dateTo.add(1, 'days');
                var _newDateFromCopy = angular.copy(newDateFrom);
                var newDateTo = _newDateFromCopy.add(diffDays, 'days');
                data.model.new_date_from = newDateFrom.format('YYYY-MM-DD');
                data.model.new_date_to = newDateTo.format('YYYY-MM-DD');
            }
            return ret;
        };

        service.budgets.preValidate = function (data) {
            var ret = service.budgets.getCollection().preValidate(data);
            if (data.action.id === 'add' || data.action.id === 'edit') {
                data.model.code = data.model.name;
                ret = true;
            }
            return ret;
        };

        service.budgets.callback = function (error, data) {
            if (_.contains(['renew', 'validate', 'done', 'confirm'], data.action.id)) {
                service.budgets.getCollection().updateItem(data.model);
            }
            if (_.contains(['renew'], data.action.id)) {
                var items = service.budgets.getCollection().getItems();
                service.budgets.getCollection().updateLocation();
            }
            service.budgets.getCollection().callback(error, data);


        };

        service.budgets.resolveData = function () {
            return swif.route.check().then(function () {
                var ret = $q.defer();
                var deferred = [];
                var data = {};
                deferred.push(service.budgets.createCollection());
                deferred.push(AchatsStocksConfigurationService.analytics.createCollection());
                $q.all(deferred).then(promises => {
                    var budgets = promises[0];
                    data.budgets = promises[0];
                    data.analytics = promises[1];
                    if (budgets.currentItem) {
                        service.budgetLines.createCollection(budgets.currentItem.id)
                            .then(function (lines) {
                                data.lines = lines;
                                ret.resolve(data);
                            });
                    } else {
                        ret.resolve(data);
                    }
                });
                return ret.promise;
            });
        };

        service.budgetLines.getCollection = function () {
            return swif.collection.getCollection(service.budgetLines.id);
        };

        service.budgetLines.createCollection = function (budgetId) {
            var filter = {};
            swif.data.addExtraFilter(filter, 'table', 'crossovered_budget_id.id', '=', budgetId);
            return swif.collection.createOrUpdate(service.budgetLines.id, 'crossovered_budget_line', filter);
        };

        service.budgetLines.preModal = function (data) {
            var parentBudget = angular.copy(data.model);
            var ret = service.budgets.getCollection().preModal(data);
            if(data.action.id === 'add') {
                data.model._type = 'crossovered_budget_line';
                data.model.planned_amount = 0.0;
                data.model.crossovered_budget_id = [parentBudget.id, parentBudget.name];
            }
            return ret;
        };

        service.budgetLines.preValidate = function (data) {
            var ret = service.budgetLines.getCollection().preValidate(data);
            if (data.action.id === 'add' || data.action.id === 'edit') {

            }
            return ret;
        };

        service.budgetLines.callback = function (error, data) {
            service.budgetLines.getCollection().callback(error, data);
            if (data) {
                if (_.contains(['add', 'edit', 'delete'], data.action.id)) {
                    // refresh selected budget to refresh amounts
                    var coll = service.budgets.getCollection();
                    if (coll.currentItem) {
                        coll.updateItem(coll.currentItem);
                    }
                }
            }
        };

        service.budgetLines.getFilters = function () {
            var ret = {
                account: {},
                budget: service.budgets.getCollectionFilter()
            };
            swif.data.addFilter(ret.account, 'type', 'not in', ['view', 'closed']);
            swif.data.sortOn(ret.account, 'code');
            return ret;
        };

        return service;
    }

    function OpenbaseBudgetsController($scope, $q, swif, data, AchatsBudgetsService) {
        'ngInject';
        console.log('init OpenbaseBudgetsController');
        $scope.budgets = data.budgets;
        $scope.analytics = data.analytics;
        $scope.lines = data.lines || undefined;
        $scope.preModal = AchatsBudgetsService.budgets.preModal;
        $scope.preValidate = AchatsBudgetsService.budgets.preValidate;
        $scope.callback = AchatsBudgetsService.budgets.callback;
        $scope.linePreModal = AchatsBudgetsService.budgetLines.preModal;
        $scope.linePreValidate = AchatsBudgetsService.budgetLines.preValidate;
        $scope.lineCallback = AchatsBudgetsService.budgetLines.callback;

        $scope.loading = { items: {} };
        $scope.refresh = function () {
            swif.message.loading($scope.loading.items);
            var deferred = [];
            _.forEach([
                'budget',
                'budget_lines',
                'analytics'
            ], function (name) {
                var collection = swif.collection.getCollection(name);
                if (collection) {
                    deferred.push(collection.getItems());
                }
            });
            $q.all(deferred).then(function () {
                swif.message.loading($scope.loading.items, 'ok');
            }, function () {
                swif.message.loading($scope.loading.items, 'ko');
            });
        };

        $scope.$watch('budgets.currentItem', function (newV, oldV) {
            if (newV && !angular.equals(newV,oldV)) {
                AchatsBudgetsService.budgetLines.createCollection(newV.id)
                .then(function (collection) {
                    if (!$scope.lines) {
                        $scope.lines = collection;
                    }
                });
            }
        });
    }

    function BudgetLineEditModalController($scope, swif, AchatsBudgetsService) {
        'ngInject';
        $scope.filters = AchatsBudgetsService.budgetLines.getFilters();
    }
})();
